<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="devices"
      :class="{
        opened: opened.indexOf('editTags') >= 0,
        'last-active': opened.indexOf('editTags') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleTagsConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="editTag()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("pridatTagK") }} {{ devices.length }}
          <span v-if="devices.length > 1">{{ $t("zarizenim") }}</span>
          <span v-else>{{ $t("zarizeni") }}</span>
        </h2>
      </div>
      <div class="side-box__content">
        <FormSelectMultiple
          :items="
            allTags.map((tag) => {
              return { text: tag }
            })
          "
          :label="$t('pridatTagy')"
          :placeholder="$t('vyberteTagZeSeznamu')"
          :value="selectedTags"
          class="mx-auto mt-3"
          item-text="text"
          item-value="text"
          side-box
          @change="selectedTags = $event"
        />
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedTagsConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleTagsConfirmation"
      @no="closeBox()"
      @yes="editTag()"
    />
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormSelectMultiple,
    SaveConfirmationModal
  },
  props: {
    opened: Array,
    devices: Array,
    technology: {
      type: String,
      default: "lora"
    }
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      tags: [],
      tagsOpened: false,
      selectedTags: [],
      writtenTags: "",
      openedTagsConfirmation: false
    }
  },
  computed: {
    allTags() {
      return this.projectStore.tagList
    }
  },
  watch: {
    allTags() {
      this.tags = this.allTags
    },
    project() {
      console.log("project")
    },
    opened() {
      /** get all tags on modal open */
      if (!this.opened.indexOf("editTags")) {
        console.log("opened")
        this.getAllTags()
      }
    }
  },
  mounted() {},
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    async getAllTags() {
      await this.projectStore.getAllTags()
    },
    setProject() {},
    resetValues() {
      ;(this.writtenTags = ""), (this.selectedTags = [])
    },
    addRemoveTag(tag) {
      if (this.selectedTags.indexOf(tag) > -1) {
        this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    editTag() {
      let counter1 = 0
      this.devices.forEach((device) => {
        let tags = device.tags

        counter1++
        let counter = 0
        this.selectedTags.forEach((tag) => {
          if (tags.indexOf(tag.text) == -1) {
            tags.push(tag.text)
          }
          counter++
          if (counter == this.selectedTags.length) {
            axios
              .put(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId + "/tags", tags, {})
              .then(() => {
                if (this.device) {
                  this.device.tags = tags
                }

                if (counter1 == this.devices.length) {
                  this.closeBox()
                }
              })
              .catch(() => {})
          }
        })
      })
    },
    addWrittenTag() {
      let written = this.writtenTags
      if (this.writtenTags.length > 0) {
        this.selectedTags.push(written)
        this.writtenTags = ""
      }
    },
    toggleTagsConfirmation() {
      this.openedTagsConfirmation = this.openedTagsConfirmation ? false : true
    }
  }
}
</script>

<style lang="scss" scoped></style>
